/*
*
* PAGE ON VOUS GUIDE JS
*
*/

window.initCarousel = require('../partials/global').initCarousel;

$(document).ready(function () {
    $('.owl-carousel').owlCarousel({
        loop: false,
        margin: 5,
        nav: true,
        dots: false,
        navText: ["", ""],

        responsive: {
            0: {
                items: 4,
                nav: true,
            },
            600: {
                items: 4,
                nav: true
            },
            1000: {
                items: 4,
                nav: true
            }
        }
    })
});


$(document).ready(function () {

    var highestBox = 0;
    $('.equal').each(function () {
        if ($(this).height() > highestBox) {
            highestBox = $(this).height();
        }
    });
    $('.equal').height(highestBox);

    initReveal('.bloc-wrapper .bloc-s', {
      delay: 100,
      useDelay: 'onload',
      interval: 100,
      reset: false,
      distance: '20px',
      origin: 'bottom',
      easing: 'ease',
      viewOffset: {
          top: -100,
          right: -300,
          bottom: 0,
          left: 0,
      }
    });

});
